import React, { useEffect, useState } from 'react';
import Layout from '../../Layout/Layout';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Col, Row, Form } from 'react-bootstrap';
import config from '../../lib/config';
import { FaRegEdit } from "react-icons/fa";
import { FaPencil, FaTrash } from 'react-icons/fa6';
import { getCmsData, updateCmsData } from '../../actions/users';
import { toast } from 'react-toastify';

const initialFormValue = {
    'identifier': "",
    'subject': "",
    'content': [],
    "logo": "",
  }

const ResourceFooterEdit = () => {


    const navigate = useNavigate();
    const { Id } = useParams();
  const location = useLocation()


  const [formValue, setFormValue] = useState(initialFormValue);
  const [validateError, setValidateError] = useState("");
  const [error, setError] = useState([])
  const [images, setImages] = useState([])
  const [showLogo, setShowLogo] = useState([])


    const onChange = (e) => {
        e.preventDefault();
        const { id, value } = e.target;
        let formData = { ...formValue, ...{ [id]: value } }
        setFormValue(formData)
      }
    
    
      const validation = async (content) => {
        let arr = [];
        content.map((value, index) => {
          let error = {}
          if (value.lable == "" || value.lable == null || value.lable == undefined) {
            error['lable'] = "Lable is required"
          } else {
            error['lable'] = ""
          }
          if (value.link == "" || value.link == null || value.link == undefined) {
            error['link'] = "Link is required"
          } else {
            error['link'] = ""
          }
          arr.push(error)
        });
    
        return {
          isValid: arr.filter((el) => el.lable != "" || el.link != "").length == 0 ? true : false,
          errors: arr
        }
      }
      const { identifier, subject, content, logo } = formValue
    
      const handleFormSubmit = async (e) => {
        e.preventDefault();
        const { isValid, errors } = await validation(content)
        if (isValid) {
          if (subject != "") {
            setError([]);
            let reqData = { subject, content, Id, identifier }
            let senddata = {
                subject,
                content: JSON.stringify(content),
                Id,
                identifier,
                image: JSON.stringify(images),
            };
            let logaarr = [];
            Object.values(images).forEach(file => {
                logaarr.push(file);
            });
            senddata.logo = logaarr;
            const updateCms = await updateCmsData(senddata);
            if(updateCms?.success){
              toast.success(updateCms?.message)
              navigate('/Cms')
            }
            else{
              toast.error(updateCms?.message)
            }
            
          } else {
            setValidateError("Subject is required")
          }
        } else {
          setError(errors);
        }
      }
    
      const getcmsoverviewdata = async () => {
        var { cmsData } = await getCmsData(Id);
        
        let formdata = {};
        formdata['identifier'] = cmsData.identifier;
        formdata['subject'] = cmsData.subject;
        formdata['content'] = cmsData.content;
        // formdata['logo'] = cmsData.content;
        setFormValue(formdata)
        let test = [];
        const setImagesData = cmsData.content.map((el, i) => { test.push("") });
        setImages(test)
        setShowLogo(test)
      }
    
      useEffect(() => {
        getcmsoverviewdata();
      }, [])
    
      const onsubChange = (e, index, type) => {
        let formData = { ...formValue }
        if (type == 'lable') {
          formData.content[index].lable = e
        }
        if (type == 'link') {
          formData.content[index].link = e
        }
        if (type == 'logo') {
          let splitMime = e.name.split(".")
          let mime = splitMime[splitMime.length - 1]
          if (mime == 'png' || mime == 'jpg' || mime == 'jpeg') {
            let instimage = [...images]
            instimage[index] = e
            setImages(instimage);
            let logos = [...showLogo]
            logos[index] = URL.createObjectURL(e)
            setShowLogo(logos);
          }
          else {
            
          }
    
        }
        setFormValue(formData)
      }
    
      const addContent = async () => {
        let formData = { ...formValue }
        formData.content.push({ lable: "", link: "" })
        setFormValue(formData)
      }
      const deleteContent = async (index) => {
        let formData = { ...formValue }
        formData.content.splice(index, 1)
        setFormValue(formData)
      }
      const ResourcesEdit = async(id) => {
        navigate({pathname:'/resource/'+id,state:location.pathname})
      }


    return (
        <Layout>
            
            <div className="resourcefooteredit">
            <Link to="/Cms" className="btn sitebtn mb-4">Back</Link>
                <h1 className="pagehead">Edit </h1>
                <div className="cardbox">
                    <Form>
                        <Row>
                            <Col xs={12} sm={12} md={12} className="mb-3">
                                <Form.Group className="d-flex align-items-end gap-4">
                                    <div className="flex-grow-1">
                                        <Form.Label>Subject</Form.Label>
                                        <Form.Control type="text" onChange={onChange} id="subject" value={formValue.subject || ''} placeholder='Enter subject' />
                                        {
                                            validateError && <span className="text-danger">{validateError}</span>
                                        }
                                    </div>
                                    <button type="button" className="btn sitebtn py-2 px-3" onClick={()=>addContent()}>Add</button>
                                </Form.Group>
                            </Col>
                            {
                                formValue?.content?.length > 0 ?
                                    (formValue?.content?.map((val, ind) =>
                                        <>
                                            <Col xs={12} sm={12} md={formValue?.identifier == "Resources"?3:5} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label>Label</Form.Label>
                                                    <Form.Control type="text" onChange={(e) => { onsubChange(e.target.value, ind, 'lable') }} id={String(ind)} value={val.lable || ''} placeholder='Enter label' />
                                                    {
                                                        error && <span className="text-danger">{error[ind]?.lable}</span>
                                                    }
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} sm={12} md={formValue?.identifier == "Resources"?3:5} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label>Link</Form.Label>
                                                    <Form.Control type="text" onChange={(e) => { onsubChange(e.target.value, ind, 'link') }} id={String(ind)} value={val.link || ''} placeholder='Enter link' />
                                                    {
                                                        error && <span className="text-danger">{error[ind]?.link}</span>
                                                    }
                                                </Form.Group>
                                            </Col>
                                            {
                                                formValue?.identifier == "Resources"
                                                ?
                                                    <Col xs={12} sm={12} md={4} className="mb-3">
                                                        <Form.Group>
                                                        <Form.Label>Choose File</Form.Label>
                                                            <input className="customed_inp form-control" type="file" onChange={(e) => { onsubChange(e.target.files[0], ind, 'logo') }} id={String(ind)} />
                                                            {
                                                                showLogo[ind] == "" ?
                                                                val.logo == ""  ?
                                                                 <p className="m-0">No File Chosen </p>
                                                                 :
                                                                 <img className="chinna_img" src={`${config.Back_Url}/cmsImages/${val.logo}`} />
                                                               : 
                                                               <img className="chinna_img" src={showLogo[ind]} />
                                                            }
                                                        </Form.Group>
                                                    </Col>
                                                :
                                                <></>
                                            }

                                        <Col xs={12} sm={12} md={2} className="mb-3">
                                          <Form.Group >
                                            <Form.Label className='d-block'>Action</Form.Label>
                                            {
                                              formValue?.identifier == "Resources"
                                                ?
                                                <>
                                                  <button className='btn btn-primary btn-sm ' onClick={() => ResourcesEdit(val?._id)} type='button'><FaRegEdit /></button>
                                                </>
                                                :
                                                <></>
                                            }
                                            <button className='btn btn-danger btn-sm ms-2' onClick={() => { deleteContent(ind) }} type='button'><FaTrash /></button>
                                          </Form.Group>
                                        </Col>
                                            
                                        </>
                                    ))
                                    :
                                    <></>
                            }
                            
                            
                        </Row>
                        <button type="button" className="btn sitebtn py-2 px-3" onClick={handleFormSubmit}>Submit</button>
                    </Form>
                </div>
            </div>
        </Layout>
    )
}

export default ResourceFooterEdit;